import EventEmitter from "eventemitter3";
import type { RopCardBase } from "../models/dados-indicadores.model";
import { SolarGridControlSSEData } from "../models/solar-grid-control-model";

type SolarGridControlRealTimeEvent = {
  connected: () => void;
  reconnecting: (reason?: string) => void;
  disconnected: (reason?: string) => void;
  error: (errorMessage: string) => void;
  solarGridControlCardUpdate: (
    solarGridControlCardUpdate: SolarGridControlSSEData
  ) => void;
  ropCardUpdate: (ropCardUpdate: RopCardBase) => void;
};

export class SolarGridControlDataEventManager extends EventEmitter<SolarGridControlRealTimeEvent> {
  private readonly _eventSource: EventSource;

  public constructor(userId: string, usinaId: string) {
    console.debug("Criando SolarGridControlDataEventManager");
    super();

    const apiBaseUrl = import.meta.env.VITE_LINK_API;
    if (!apiBaseUrl) {
      console.warn("API BASE URL não definida");
    }

    const sseUrl = new URL(
      "/api/v1/SolarGridControlData",
      import.meta.env.VITE_LINK_API
    );
    sseUrl.searchParams.set("userId", userId);
    sseUrl.searchParams.set("usinaId", usinaId);

    this._eventSource = new EventSource(sseUrl);
    this._eventSource.onopen = this.handleOpen.bind(this);
    this._eventSource.onerror = this.handleError.bind(this);
    this._eventSource.onmessage = this.handleMessageWithoutEvent.bind(this);
    this._eventSource.addEventListener(
      "solarGridControlCardUpdate",
      this.handleSolarGridControlCardUpdate.bind(this)
    );
    this._eventSource.addEventListener(
      "ropCardUpdate",
      this.handleRopCardUpdate.bind(this),
    );
    this._eventSource.addEventListener(
      "clienterror",
      this.handleClientError.bind(this)
    );
  }

  private handleOpen(_ev: Event) {
    // console.debug("Lendo Open", _ev);
    this.emit("connected");
  }

  private handleError(_ev: Event) {
    // console.debug("Lendo Error", _ev);
    this.emit("reconnecting");
  }

  private handleMessageWithoutEvent(event: MessageEvent<unknown>) {
    console.debug("Lendo Message sem evento", event);
  }

  private handleSolarGridControlCardUpdate(event: MessageEvent<unknown>) {
    // console.debug("Lendo evento solarGridControlCardUpdate", event);
    if (!event.data || typeof event.data !== "string") {
      console.warn(
        "Evento solarGridControlCardUpdate vazio ou com tipo inválido",
        event
      );
      return;
    }

    let solarGridControlData: SolarGridControlSSEData;
    try {
      const parsedEvtData = JSON.parse(event.data);
      solarGridControlData = parsedEvtData;
    } catch (error) {
      console.error(
        error,
        "Erro ao fazer parse do evento handleSolarGridControlCardUpdate",
        event
      );
      return;
    }

    this.emit("solarGridControlCardUpdate", solarGridControlData);
  }

  private handleRopCardUpdate(event: MessageEvent<unknown>) {
    // console.debug("Lendo evento ropCardUpdate", event);
    if (!event.data || typeof event.data !== "string") {
      console.warn("Evento ropCardUpdate vazio ou com tipo inválido", event);
      return;
    }

    let ropCardData: RopCardBase;
    try {
      const parsedEvtData = JSON.parse(event.data);
      ropCardData = parsedEvtData;
    } catch (error) {
      console.error(
        error,
        "Erro ao fazer parse do evento handleRopCardUpdate",
        event,
      );
      return;
    }

    this.emit("ropCardUpdate", ropCardData);
  }

  private handleClientError(event: MessageEvent<unknown>) {
    // console.debug("Lendo evento ClientError", event);
    this.disconnect("Erro nas informações do cliente tempo real");

    if (!event.data || typeof event.data !== "string") {
      console.warn("Evento ClientError vazio ou com tipo inválido", event);
      return;
    }

    const errorMessage = event.data;
    this.emit("error", errorMessage);
  }

  private disconnect(reason?: string) {
    console.debug("Desconectando SolarGridControlDataEventManager", reason);
    this.emit("disconnected", reason);
    this._eventSource.close();
  }

  public destroy() {
    console.debug("Destruindo SolarGridControlDataEventManager");
    this.disconnect("Cliente cancelou a conexão");
    this.removeAllListeners();
  }
}
